import React from 'react';
import { Button } from 'swag-client-common/components/ui/button';
import { LearnMoreLink } from './learn-more-link';
import css from './box-introduction-info.scss';
const BoxIntroductionInfo = ({
  onClose,
  onNext,
  hasUnsavedChanges
}) => /*#__PURE__*/React.createElement("div", {
  className: css.introWrapper
}, /*#__PURE__*/React.createElement("div", {
  className: css.img
}), /*#__PURE__*/React.createElement("div", {
  className: css.info
}, /*#__PURE__*/React.createElement("header", {
  className: css.header
}, "Hey, you\u2019re creating a box!"), /*#__PURE__*/React.createElement("p", {
  className: css.text
}, "Perfect for onboarding, employee appreciation, customer outreach and more. Send the good stuff, in a box!", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "You can build as many boxes as you want using the items in your cart.", ' ', /*#__PURE__*/React.createElement(LearnMoreLink, null)), /*#__PURE__*/React.createElement("div", {
  className: css.buttons
}, /*#__PURE__*/React.createElement(Button, {
  dataButton: "GetStarted",
  type: "secondary",
  className: css.button,
  onClick: onNext
}, "Get Started"), /*#__PURE__*/React.createElement(Button, {
  type: "defaultGrey",
  className: css.button,
  onClick: () => onClose(hasUnsavedChanges)
}, "No Thanks"))));
export default BoxIntroductionInfo;